<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>{{translate(locale.allQuotation)}}</h4>
		</div>
		<div class="md-layout-item md-medium-size-50 md-size-50 text-right">
			<md-button class="md-raised md-primary" @click="$router.push('/quotation_and_bidding/new')">{{translate(locale.newQuotation)}}</md-button>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<!-- <el-tabs v-model="tabName" v-if="loaded">
						<el-tab-pane label="My All Activities" name="first"></el-tab-pane>
						<el-tab-pane label="Create New Activity" name="second"></el-tab-pane>
					</el-tabs> -->
					<div v-if="loaded">
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-50">
								<md-field>
									<label>{{translate(locale.searchQuotation)}}</label>
									<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-25">
								<md-field>
									<label>{{translate(locale.status)}}</label>
									<md-select :placeholder="translate(locale.statusAll)" v-model="search.status">
										<md-option value="">{{translate(locale.all)}}</md-option>
										<md-option value="1">{{translate(locale.active)}}</md-option>
										<md-option value="2">{{translate(locale.drafted)}}</md-option>
										<md-option value="3">{{translate(locale.disabled)}}</md-option>
									</md-select>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-25">
								<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">{{translate(locale.search)}}</md-button>
							</div>
						</div>
						<md-table v-if="tenderList.length > 0">
							<md-table-row>
								<md-table-head></md-table-head>
								<md-table-head>{{translate(locale.title)}}</md-table-head>
								<md-table-head>{{translate(locale.total_apply)}}</md-table-head>
								<md-table-head style="min-width: 180px;">{{translate(locale.deadline)}}</md-table-head>
								<md-table-head style="min-width: 180px;">{{translate(locale.lastUpdate)}}</md-table-head>
								<md-table-head>{{translate(locale.status)}}</md-table-head>
								<md-table-head>{{translate(locale.action)}}</md-table-head>
							</md-table-row>

							<md-table-row v-for="(tender, index) in tenderList">
								<!-- <md-table-cell></md-table-cell> -->
								<md-table-cell>​{{ index + 1 }}</md-table-cell>
								<md-table-cell><b>{{tender.name}}</b><br>{{translate(tender.location_province_name)}}, {{translate(tender.tender_category_name)}} ({{translate(tender.tender_sub_category_name)}})</md-table-cell>
								<md-table-cell class="text-center">
									{{tender.total_submission || 0}} {{translate(locale.application)}}
								</md-table-cell>
								<md-table-cell><b>{{translate(config.datelify(tender.deadline_date))}}</b><br>({{translate(config.timelify(tender.deadline_date))}})</md-table-cell>
								<md-table-cell><b>{{ tender.first_name }} {{ tender.last_name }}</b><br>{{ translate(config.datelify(tender.updated_date)) }}</md-table-cell>
								<md-table-cell>
									<span class="late" v-if="tender.status == 0">{{translate(locale.disabled)}}</span>
									<span class="gray" v-if="tender.status == 2">{{translate(locale.drafted)}}</span>
									<span class="green" v-if="tender.status == 1">{{translate(locale.active)}}</span>
								</md-table-cell>
								<md-table-cell>
									<router-link :to="'quotation_and_bidding/submission/' + tender.hash">
										<md-button class="md-just-icon md-simple md-info">
											<md-icon>summarize</md-icon>
											<md-tooltip md-direction="top">{{translate(locale.viewSubmission)}}</md-tooltip>
										</md-button>
									</router-link>
									
									<a :href="config.redirect_url + '/quotation-and-bidding/' + tender.hash" target="_blank">
										<md-button class="md-just-icon md-simple md-primary" v-if="tender.status == 1">
											<md-icon>visibility</md-icon>
											<md-tooltip md-direction="top">{{translate(locale.viewThis)}}</md-tooltip>
										</md-button>
									</a>
									<md-button class="md-just-icon md-simple md-primary" v-if="tender.status == 0" @click="onEnable(tender.hash)">
										<md-icon>check_circle</md-icon>
										<md-tooltip md-direction="top">{{translate(locale.enableThis)}}</md-tooltip>
									</md-button>
									<md-button class="md-just-icon md-simple md-primary" v-if="tender.status == 2" @click="onEnable(tender.hash)">
										<md-icon>fact_check</md-icon>
										<md-tooltip md-direction="top">{{translate(locale.publishThis)}}</md-tooltip>
									</md-button>
									<router-link :to="'quotation_and_bidding/edit/' + tender.hash">
										<md-button class="md-just-icon md-simple md-info">
											<md-icon>edit</md-icon>
											<md-tooltip md-direction="top">{{translate(locale.editThis)}}</md-tooltip>
										</md-button>
									</router-link>

									<md-button class="md-just-icon md-simple md-warn" v-if="tender.status == 1" @click="onDisable(tender.hash)">
										<md-icon>hide_source</md-icon>
										<md-tooltip md-direction="top">{{translate(locale.disableThis)}}</md-tooltip>
									</md-button>
									
									<md-button class="md-just-icon md-simple md-danger" v-if="tender.status == 0 || tender.status == 2" @click="onDelete(tender.hash)">
										<md-icon>delete</md-icon>
										<md-tooltip md-direction="top">{{translate(locale.deleteThis)}}</md-tooltip>
									</md-button>
								</md-table-cell>
							</md-table-row>
						</md-table>
						<h5 class="text-center" v-if="tenderList.length == 0 && loaded == true">{{translate(locale.noQuotation)}}</h5>
						<div class="places-buttons text-center" v-if="loadMore">
							<md-button class="md-primary" @click="searchHandler(true)">{{translate(locale.showMore)}}</md-button>
						</div>
					</div>

					<md-dialog-confirm :md-active.sync="deleteDialogActive" :md-title="translate(locale.deleteQuotation)" :md-confirm-text="translate(locale.delete)"
						:md-cancel-text="translate(locale.cancel)" @md-cancel="onCancel" @md-confirm="onDelete" />
						<md-dialog-confirm :md-active.sync="disableDialogActive" :md-title="translate(locale.disableQuotation)" :md-confirm-text="translate(locale.disable)"
						:md-cancel-text="translate(locale.cancel)" @md-cancel="onCancel" @md-confirm="onDisable" />
				</md-card-content>
			</md-card>
		</div>
	</div>
		
	</div>

</template>

<script>

	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				loaded: false,
				deleteDialogActive: false, deleteSelected: '',
				disableDialogActive: false, disableSelected: '',
				search: { text: "", status: "", type: "" },
				loadMore: false,
				tenderList: []
			}
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/profile/tender/search", {
					text: this.search.text,
					status: this.search.status,
					offset: more ? this.tenderList.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.tenderList = more ? this.tenderList.concat(data.body.data) : data.body.data;
				})
			},

			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete(hash) {
				if(this.deleteSelected == "") {
					this.deleteDialogActive = true;
					this.deleteSelected = hash;
					return;
				}
				this.$http.post(this.config.api + "/profile/tender/delete", {
					hash: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have deleted the quotation/bidding successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onDisable(hash) {

				if(this.disableSelected == "") {
					this.disableDialogActive = true;
					this.disableSelected = hash;
					return;
				}
				this.$http.post(this.config.api + "/profile/tender/disable", {
					hash: this.disableSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have disabled the quotation/bidding successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},

			onEnable(hash) {

				this.$http.post(this.config.api + "/profile/tender/enable", {
					hash: hash
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have enabled the quotation/bidding successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.disableSelected = ""
				this.deleteDialogActive = false
				this.disableDialogActive = false
			},	
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Quotation/View.vue